const translations = {
  // SEO
  siteTitle: "Shopee Ultra-Hackathon 2020",
  siteDesc: "Shopee Ultra-Hackathon is a challenging 36-hour hackathon organised by Shopee where participants are required to use any of the given APIs to build features to increase user engagement and interact with the Shopee live environment. The hackathon will take place at Shopee Building from 13 to 15 March 2020. It is free and open to tech and non-tech professionals in Singapore as well as students enrolled in universities in Singapore (including exchange students). Register yourself as a group of 2 to 4 people and stand a chance to win over a total SGD $30,000 in cash prizes! Not only will participants get a chance to see the code they write go live in 36 hours on the Shopee platform, this competition also provides an opportunity for the participants to interact with Shopee’s developers.  All you have to do is register and join the fun.",
  siteURL: "https://careers.shopee.sg/ultrahackathon",
  siteImageURL: "https://careers.shopee.sg/ultrahackathon/images/ultra.jpg",
  seoStartdate: "",
  seoEnddate: "",
  seoPerformer: "Shopee Singapore",
  seolocationName: "Shopee Singapore",
  seolocationAddress: "techsg@shopee.com",
  seohasMap: "",
  seoAudienceType: "Developers and aspiring developers!",
  // modal
  modalText: "hackathon_modalText",
  // Nav
  navAbout: "hackathon_navAbout",
  navTheme: "hackathon_navTheme",
  navPrizes: "hackathon_navPrizes",
  navJudge: "hackathon_navJudge",
  navTimeline: "hackathon_navTimeline",
  navPartners: "hackathon_navPartners",
  navContact: "hackathon_navContact",
  navFaq: "hackathon_navFaq",
  career: "hackathon_career",
  careerLink: "https://careers.shopee.sg/",
  //Hero
  dateRange: "",
  heroDesc: "hackathon_heroDesc",
  heroSubtitle: "hackathon_heroSubtitle",
  registerNow: "hackathon_registerNow",
  heroClockSubtitle: "",
  //Intro
  introduction: "hackathon_introduction",
  introLi01: "hackathon_introLi01",
  introLi02: "hackathon_introLi02",
  introLi03: "hackathon_introLi03",
  introData: [
    {
      title: "hackathon_introData01_title",
      image: "about.png",
      desc: "hackathon_introData01_desc",
    },
    {
      title: "hackathon_introData02_title",
      image: "whyshouldyoujoin.png",
      desc: "hackathon_introData02_desc",
    },
  ],
  //prize
  prizes: "hackathon_prizes",
  prizesData: [
    {
      name: "hackathon_prizesData01_name",
      image: "1.png",
      price: "hackathon_prizesData01_price",
    },
    {
      name: "hackathon_prizesData02_name",
      image: "2.png",
      price: "hackathon_prizesData02_price",
    },
    {
      name: "hackathon_prizesData03_name",
      image: "3.png",
      price: "hackathon_prizesData03_price",
    },
    {
      name: "hackathon_prizesData04_name",
      image: "popular.svg",
      price: "hackathon_prizesData04_price",
    },
    {
      name: "hackathon_prizesData05_name",
      image: "innovative.png",
      price: "hackathon_prizesData05_price",
    },
    {
      name: "hackathon_prizesData06_name",
      image: "impressive.png",
      price: "hackathon_prizesData06_price",
    },
  ],
  //Judge
  judge: "hackathon_judge",
  judgeData: [
    {
      title: "hackathon_judgeData01_title",
      li: [
        "hackathon_judgeData01_li_1",
        "hackathon_judgeData01_li_2"
      ],
    },
    {
      title: "hackathon_judgeData02_title",
      li: [
        "hackathon_judgeData02_li_1",
        "hackathon_judgeData02_li_2",
      ],
    },
    {
      title: "hackathon_judgeData03_title",
      li: [
        "hackathon_judgeData03_li_1",
        "hackathon_judgeData03_li_2",
        "hackathon_judgeData03_li_3",
      ],
    },
    {
      title: "hackathon_judgeData04_title",
      li: [
        "hackathon_judgeData04_li_1",
        "hackathon_judgeData04_li_2",
        "hackathon_judgeData04_li_3",
      ],
    },
    {
      title: "hackathon_judgeData05_title",
      li: [
        "hackathon_judgeData05_li_1",
        "hackathon_judgeData05_li_2",
      ],
    },
  ],
  //Timeline
  timeline: "hackathon_timeline",
  timelineSubtitle: "hackathon_timelineSubtitle",
  timelineData: [
    {
      date: "",
      title: "hackathon_timelineData01_title",
      desc: [
        {
          ul: [
            {
              li: "hackathon_timelineData01_desc_1",
            },
            {
              li: "hackathon_timelineData01_desc_2",
            },
            {
              ul: [
                {
                  li: "hackathon_timelineData01_desc_3",
                },
                {
                  li: "hackathon_timelineData01_desc_4",
                },
              ],
            },
          ]
        }
      ]
    },
    {
      date: "",
      title: "hackathon_timelineData02_title",
      desc: [
        {
          ul: [
            {
              li: "hackathon_timelineData02_desc_1",
            },
            {
              li: "hackathon_timelineData02_desc_2",
            },
          ]
        }
      ]
    },
    {
      date: "",
      title: "hackathon_timelineData04_title",
      desc: [
        {
          ul: [
            {
              li: "hackathon_timelineData04_desc",
            }
          ]
        }
      ]
    },
    {
      date: "",
      title: "hackathon_timelineData03_title",
      desc: [
        {
          ul: [
            {
              li: "hackathon_timelineData03_desc_1",
            },
            // {
            //   li: "hackathon_timelineData03_desc_2",
            // },
            {
              li: "hackathon_timelineData03_desc_3",
            },
          ]
        }
      ]
    },
  ],
  timelineNote: "hackathon_timelineNote",
  //partner
  partners: "hackathon_partners",
  organized: "hackathon_organized",
  organizedData: [
    {
      name: "hackathon_organizedData01_name",
      image: "shopee_logo_en.png",
      link: "https://careers.shopee.sg/",
    },
  ],
  governmentPartner: "hackathon_governmentPartner",
  governmentPartnerData: [
    {
      name: "hackathon_governmentPartnerData01_name",
      image: "disg.png",
      link: "https://www.imda.gov.sg/for-industry/Digital-Industry-Singapore-DISG",
    },
    {
      name: 'hackathon_governmentPartnerData02_name',
      image: 'TeSA.png',
      link: 'https://www.imda.gov.sg/imtalent/about-us/national-talent-development-initiatives/techskills-accelerator--tesa'
    },
    {
      name: 'hackathon_governmentPartnerData03_name',
      image: 'IMDA.jpg',
      link: 'https://www.imda.gov.sg/'
    }
  ],
  schoolPartner: "hackathon_schoolPartner",
  schoolData: [
    {
      name: "hackathon_schoolData01_name",
      displayName: "hackathon_schoolData01_name",
      link: "https://www.ntu.edu.sg/cao/Pages/index.aspx",
    },
    {
      name: "hackathon_schoolData02_name",
      image: "ntu.jpg",
      link: "http://scse.ntu.edu.sg/Pages/Home.aspx",
    },
    {
      name: "hackathon_schoolData03_name",
      image: "nus.png",
      link: "http://nus.edu.sg/cfg/",
    },
    {
      name: "hackathon_schoolData04_name",
      image: "SIT_Logo.png",
      link: "https://www.singaporetech.edu.sg/",
    },
    {
      name: "hackathon_schoolData05_name",
      image: "SUTD_logo.png",
      link: "https://www.sutd.edu.sg/",
    },
    {
      name: "hackathon_schoolData06_name",
      image: "NUS_school_computing.png",
      link: "https://www.comp.nus.edu.sg/",
    },
    {
      name: "hackathon_schoolData07_name",
      image: "NTU_ML&DA.JPG",
      link: "http://www.eee.ntu.edu.sg/programmes/mlda/Pages/Home.aspx",
    },
    {
      name: "hackathon_schoolData08_name",
      image: "SMU.png",
      link: "https://sis.smu.edu.sg/master-it-business",
    },
    {
      name: "hackathon_schoolData09_name",
      image: "OAR.png",
      link: "https://alumni.smu.edu.sg/",
    },
    {
      name: "hackathon_universityPartnersData16_name",
      image: "NTU_College_of_Engineering.jpg",
      link: "http://www.coe.ntu.edu.sg/"
    },
    {
      name: "hackathon_schoolData10_name",
      image: "DigiPen_Singapore_WEB_RED.jpg",
      link: 'https://www.digipen.edu.sg/?gclid=EAIaIQobChMIz_ytj5ur6QIViwsrCh16wwL8EAAYASAAEgL0afD_BwE'
    },
    {
      name: "hackathon_schoolData11_name",
      image: "CoBrand-BusinessSchool-COLS.jpg",
      link: 'https://bschool.nus.edu.sg/'
    },
  ],
  universityPartners: "hackathon_universityPartners",
  universityPartnersData: [
    {
      name: "hackathon_universityPartnersData01_name",
      image: "NUS_Statistics_Society.png",
      link: "https://www.instagram.com/nusstatssoc/"
    },
    {
      name: "hackathon_universityPartnersData02_name",
      image: "NUS_Industrial&Systems_Engineering.png",
      link: "https://nusiseclub.com/#/"
    },
    {
      name: "hackathon_universityPartnersData03_name",
      image: "SMU_EllipSIS.jpg",
      link: "http://ellipsis.sis.smu.edu.sg/"
    },
    {
      name: "hackathon_universityPartnersData04_name",
      image: "ieeentu.png",
      link: "http://www.ieeentu.com/"
    },
    {
      name: "hackathon_universityPartnersData05_name",
      image: "IEEE_SUTD.png",
      link: "http://sutd-ieee.github.io/",
    },
    {
      name: "hackathon_universityPartnersData06_name",
      image: "Institute_Engineers_SUTD.jpg",
      link: "https://www.facebook.com/IES-SUTD-1554216541505233/",
    },
    {
      name: "hackathon_universityPartnersData07_name",
      image: "Institution_Engineers_NUS.jpg",
      link: "https://www.facebook.com/iesnus/",
    },
    {
      name: "hackathon_universityPartnersData09_name",
      image: "IET_ON_CAMPUS.png",
      link: "https://www.facebook.com/ietntuss/",
    },
    {
      name: "hackathon_universityPartnersData10_name",
      image: "nus_comp_club.png",
      link: "https://nuscomputing.com/",
    },
    {
      name: "hackathon_universityPartnersData11_name",
      image: "IES_SIT.jpg",
      link: "https://www.singaporetech.edu.sg/studentlife/clubs-and-committees/special-interest/institutional-engineering-singapore-ies",
    },
    {
      name: "hackathon_universityPartnersData12_name",
      image: "NUS_Fintech.png",
      link: "https://www.fintechsociety.comp.nus.edu.sg/"
    },
    {
      name: "hackathon_universityPartnersData13_name",
      image: "Engin_Club.png",
      link: "http://enginclub.com/"
    },
    {
      name: "hackathon_universityPartnersData14_name",
      image: "pad.png"
    },
    {
      name: "hackathon_universityPartnersData17_name",
      image: "IEEE_NUS_Student Branch_logo.jpeg",
      link: "http://nusieee.org/"
    },
    {
      name: "hackathon_universityPartnersData19_name",
      image: "SUTD_logo.png",
      link: "https://www.sutd.edu.sg/",
    },
    {
      name: "hackathon_universityPartnersData20_name",
      image: "NUS-BACT_Logo.png",
      link: 'https://nusbact.com/'
    },
    {
      name: "hackathon_universityPartnersData21_name",
      image: "SIT Geeks.png",
      link: 'https://www.singaporetech.edu.sg/studentlife/clubs-and-committees/special-interest/geeks'
    },
    {
      name: "hackathon_universityPartnersData22_name",
      image: 'NUS MSL Logo.jpg',
      link: 'https://nusmsl.com'
    },
    {
      name: "hackathon_universityPartnersData23_name",
      image: 'Technology Club - Full v2.png',
      link: 'https://mba.nus.edu.sg/ '
    },
    {
      name: "hackathon_universityPartnersData24_name",
      image: 'NTU EEE Alumni Association.png',
      link: 'https://www.eeeaa.org/'
    }
  ],
  supportPartners: "hackathon_supportPartners",
  supportPartnersData: [
    {
      name: "hackathon_supportPartnersData01_name",
      image: "Lato_Reactor_School.png",
      link: "https://www.reactor.school/",
    },
    {
      name: "hackathon_supportPartnersData02_name",
      image: "pydata-logo-banner.png",
      link: "https://www.meetup.com/PyData-SG/",
    },
    {
      name: "hackathon_supportPartnersData03_name",
      image: "dotnetsg.png",
      link: "https://www.meetup.com/NET-Developers-SG/",
    },
    {
      name: "hackathon_supportPartnersData04_name",
      image: "smartacadem.png",
      link: "https://smartcademy.sg/",
    },
    {
      name: "hackathon_supportPartnersData05_name",
      image: "vertical_Institute.png",
      link: "http://www.verticalinstitute.com/"
    },
    // {
    //   name: "hackathon_supportPartnersData06_name",
    //   image: "Rocket_Academ.png",
    //   link: "https://www.rocketacademy.co/"
    // },
    {
      name: "hackathon_supportPartnersData07_name",
      image: "Roboto_Coding_Academy.png",
      link: "https://roboto.sg/"
    },
    {
      name: "hackathon_universityPartnersData15_name",
      image: "NUS_ISS.png",
      link: "https://www.iss.nus.edu.sg/"
    },
    {
      name: "hackathon_universityPartnersData25_name",
      image: 'NTUitive.jpg',
      link: 'https://www.ntuitive.sg'
    }
  ],
  partnershipOpportunities: "hackathon_partnershipOpportunities",
  partnershipOpportunitiesData: [
    {
      title: "hackathon_partnershipData01_title",
      desc: [
        "hackathon_partnershipData01_desc_1",
        "hackathon_partnershipData01_desc_2"
      ]
    },
    {
      title: "hackathon_partnershipData02_title",
      desc: [
        "hackathon_partnershipData02_desc_1",
        "hackathon_partnershipData02_desc_2",
        "hackathon_partnershipData02_desc_3",
        "hackathon_partnershipData02_desc_4"
      ]
    },
    {
      title: "hackathon_partnershipData03_title",
      desc: [
        "hackathon_partnershipData03_desc_1",
        "hackathon_partnershipData03_desc_2",
        "hackathon_partnershipData03_desc_3"
      ]
    },
  ],
  //faq
  faq: "hackathon_faq",
  faqTitle01: "hackathon_faqTitle01",
  faqData01: [
    {
      question: "hackathon_faqData01_que_1",
      answer: "hackathon_faqData01_ans_1"
    },
    {
      question: "hackathon_faqData01_que_2",
      answer: "hackathon_faqData01_ans_2"
    },
    {
      question: "hackathon_faqData01_que_3",
      answer: "hackathon_faqData01_ans_3",
    },
    {
      question: "hackathon_faqData01_que_4",
      answer: "hackathon_faqData01_ans_4",
    },
    {
      question: "hackathon_faqData01_que_5",
      answer: "hackathon_faqData01_ans_5",
    },
    {
      question: "hackathon_faqData01_que_6",
      answer: "hackathon_faqData01_ans_6"
    },
    {
      question: "hackathon_faqData01_que_7",
      answer: "hackathon_faqData01_ans_7"
    },
  ],
  faqTitle02: "hackathon_faqTitle02",
  faqData02: [
    {
      question: "hackathon_faqData02_que_1",
      answer: "hackathon_faqData02_ans_1",
    },
    {
      question: "hackathon_faqData02_que_2",
      answer: "hackathon_faqData02_ans_2",
    },
    {
      question: "hackathon_faqData02_que_3",
      answer: "hackathon_faqData02_ans_3",
    },
  ],
  faqTitle03: "hackathon_faqTitle03",
  faqData03: [
    {
      question: "hackathon_faqData03_que_1",
      answer: "hackathon_faqData03_ans_1",
    },
    {
      question: "hackathon_faqData03_que_2",
      answer: "hackathon_faqData03_ans_2",
    },
    {
      question: "hackathon_faqData03_que_3",
      answer: "hackathon_faqData03_ans_3",
    },
    {
      question: "hackathon_faqData03_que_4",
      answer: "hackathon_faqData03_ans_4",
    },
    {
      question: "hackathon_faqData03_que_5",
      answer: "hackathon_faqData03_ans_5",
    },
    {
      question: "hackathon_faqData03_que_6",
      answer: [
        "hackathon_faqData03_ans_6_1",
        "hackathon_faqData03_ans_6_2",
        "hackathon_faqData03_ans_6_3"
      ]
    },
    {
      question: "hackathon_faqData03_que_7",
      answer: [
        "hackathon_faqData03_ans_6_1",
        "hackathon_faqData03_ans_6_2",
        "hackathon_faqData03_ans_6_3"
      ]
    },
  ],
  faqTitle04: "hackathon_faqTitle04",
  faqData04: [
    {
      question: "hackathon_faqData04_que_1",
      answer: "hackathon_faqData04_ans_1",
    },
    {
      question: "hackathon_faqData04_que_2",
      answer: "hackathon_faqData04_ans_2",
    },
  ],
  faqTitle05: "hackathon_faqTitle05",
  faqData05: [
    {
      question: "hackathon_faqData05_que_1",
      answer: "hackathon_faqData05_ans_1",
    },
  ],
  //contact
  contactDesc01: "hackathon_contactDesc01",
  contactBtn: "hackathon_contactBtn",
  contactDesc02: "hackathon_contactDesc02",
  contactEmail: "techsg@shopee.com",
  //footer
  instagram: "hackathon_instagram",
  instagramLink: "https://www.instagram.com/LifeatShopee",
  linkedin: "hackathon_linkedin",
  linkedinLink: "https://www.linkedin.com/company/shopee/",
  copyright: "hackathon_copyright",
  termsAndCondition: "hackathon_termsAndCondition",
  privacyPolicy: "hackathon_privacyPolicy",
  theme: {
    title: 'hackathon_theme_title',
    desc: 'hackathon_theme_desc',
    img: 'images/theme.png'
  }
}

export default translations;